// Notification sound utility for release approvals

// Create a simple notification beep using Web Audio API
const playBeepSound = () => {
  try {
    const audioContext = new (
      window.AudioContext || window.webkitAudioContext
    )();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Configure the sound
    oscillator.frequency.value = 800; // Frequency in Hz
    oscillator.type = "sine"; // Sine wave for a pleasant tone

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(
      0.01,
      audioContext.currentTime + 0.5,
    );

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.5);
  } catch (error) {
    console.error("Error playing beep sound:", error);
  }
};

// Play text-to-speech notification
const playTextToSpeech = () => {
  try {
    // Use Web Speech API for text-to-speech
    const utterance = new SpeechSynthesisUtterance(
      "Hello Boss, You have a notification",
    );
    utterance.rate = 1.3; // Faster speed (1.0 is normal, 1.3 is 30% faster)
    utterance.pitch = 1.0; // Normal pitch
    utterance.volume = 1.0; // Full volume

    window.speechSynthesis.speak(utterance);
  } catch (error) {
    console.error("Error playing text-to-speech:", error);
  }
};

// Play notification for new releases: beep sound followed by text-to-speech
export const playNewReleaseSound = () => {
  // Play the beep sound first
  playBeepSound();

  // Wait a bit, then play text-to-speech
  setTimeout(() => {
    playTextToSpeech();
  }, 600);
};
